module.exports = __webpack_public_path__ + "static/media/search.4ca98e60.svg";